// ELENCOS REAIS DA NBA.
//
// ⚠️ ARQUIVO GERADO. Não edite à mão: rode `node scripts/coletar-nba.mjs`.
//
// Fonte: stats.nba.com (oficial), coletado em 2026-09-04.
// Elenco da temporada 2026-27; produção da temporada 2025-26.
//
// FATO, verificável na fonte: quem está no elenco, posição, idade.
//
// ⚠️ `overall` e `potential` são ESTIMATIVAS -- não existe avaliação oficial
// de atleta. Aqui elas saem da PRODUÇÃO REAL da temporada passada (minutos,
// PIE, pontos, rebotes, assistências, saldo, uso), colocada na pirâmide da
// liga. Quem não jogou -- calouro, quem veio de fora -- é estimado pela
// escolha do draft. A conta inteira está no script, comentada.
//
// O 6º item, quando existe, é o PERFIL: também vem da estatística real
// (quem arremessa de 3, quem não arremessa, quem distribui, quem defende).

// 30 clubes, 390 atletas.
/** [nome, posicao, overall, potencial, idade, perfil?] -- indexado pelo NOME
 *  do clube, que e como src/data/real-rosters.js procura o elenco. */
export const NBA_ROSTERS = {
  "Atlanta Hawks": [
    ["Jalen Johnson", 'ARM', 92, 98, 24, 'armador'],
    ["Nickeil Alexander-Walker", 'AA', 83, 84, 28, 'atirador'],
    ["Dyson Daniels", 'AA', 82, 88, 23, 'defensor'],
    ["CJ McCollum", 'AA', 81, 81, 34, 'atirador'],
    ["Onyeka Okongwu", 'AP', 81, 84, 25, 'atirador'],
    ["Jock Landale", 'PIV', 76, 76, 30],
    ["Aaron Wiggins", 'AA', 75, 76, 27],
    ["Devin Carter", 'ARM', 75, 81, 24],
    ["Luguentz Dort", 'AA', 74, 75, 27],
    ["Ryan Nembhard", 'ARM', 74, 80, 23, 'armador'],
    ["Corey Kispert", 'ALA', 74, 75, 27, 'atirador'],
    ["Kingston Flemings", 'AA', 73, 90, 19],
    ["Buddy Hield", 'AA', 72, 72, 33],
  ],
  "Boston Celtics": [
    ["Jayson Tatum", 'ALA', 91, 92, 28],
    ["Derrick White", 'ARM', 84, 84, 32],
    ["Paul George", 'ALA', 83, 83, 36, 'atirador'],
    ["Payton Pritchard", 'ARM', 83, 84, 28, 'atirador'],
    ["Neemias Queta", 'PIV', 80, 81, 27, 'paredao'],
    ["Mitchell Robinson", 'PIV', 77, 78, 28, 'paredao'],
    ["Sam Hauser", 'ALA', 75, 76, 28, 'atirador'],
    ["Luka Garza", 'PIV', 75, 76, 27, 'sem3'],
    ["Baylor Scheierman", 'AA', 73, 76, 25],
    ["Jordan Walsh", 'AA', 72, 82, 22],
    ["Mike Conley", 'ARM', 71, 71, 38],
    ["Ron Harper Jr.", 'AA', 70, 73, 26],
    ["Hugo Gonzalez", 'AA', 70, 83, 20],
  ],
  "Cleveland Cavaliers": [
    ["Donovan Mitchell", 'ARM', 91, 92, 29, 'armador'],
    ["James Harden", 'ARM', 90, 90, 37, 'atirador'],
    ["Evan Mobley", 'PIV', 85, 88, 25],
    ["Jarrett Allen", 'PIV', 83, 84, 28, 'sem3'],
    ["Peyton Watson", 'AA', 79, 85, 23],
    ["Jaylon Tyson", 'AA', 78, 84, 23, 'atirador'],
    ["Sam Merrill", 'AA', 77, 77, 30, 'atirador'],
    ["Thomas Bryant", 'AP', 74, 75, 29],
    ["Craig Porter Jr.", 'ARM', 74, 77, 26],
    ["Riley Minix", 'ALA', 72, 75, 25],
    ["Tristan Enaruna", 'ALA', 72, 75, 25],
    ["Tyrese Proctor", 'AA', 71, 81, 22],
    ["Nae'Qwan Tomlin", 'ALA', 71, 74, 25, 'sem3'],
  ],
  "New Orleans Pelicans": [
    ["Zion Williamson", 'ALA', 85, 88, 26, 'sem3'],
    ["Trey Murphy III", 'ALA', 85, 88, 26, 'atirador'],
    ["Dejounte Murray", 'ARM', 84, 85, 29],
    ["Saddiq Bey", 'AA', 82, 83, 27, 'atirador'],
    ["Derik Queen", 'PIV', 79, 89, 21, 'sem3'],
    ["Jeremiah Fears", 'AA', 78, 91, 19],
    ["Jordan Poole", 'AA', 76, 77, 27],
    ["Herbert Jones", 'ALA', 75, 76, 27, 'defensor'],
    ["DeAndre Jordan", 'PIV', 74, 74, 38],
    ["Yves Missi", 'PIV', 74, 84, 22, 'sem3'],
    ["Trendon Watford", 'AA', 73, 76, 25],
    ["Karlo Matkovic", 'AP', 73, 76, 25, 'sem3'],
    ["Bryce McGowens", 'AA', 72, 78, 23],
  ],
  "Chicago Bulls": [
    ["Josh Giddey", 'ARM', 86, 92, 23, 'armador'],
    ["Norman Powell", 'AA', 82, 82, 33, 'atirador'],
    ["Tre Jones", 'ARM', 81, 84, 26, 'armador'],
    ["Matas Buzelis", 'ALA', 80, 90, 21],
    ["Nic Claxton", 'PIV', 79, 80, 27, 'paredao'],
    ["Zach Collins", 'AP', 77, 78, 28],
    ["Jalen Smith", 'AP', 77, 80, 26, 'atirador'],
    ["Leonard Miller", 'AP', 74, 84, 22],
    ["Caleb Wilson", 'AP', 73, 91, 20],
    ["Isaac Okoro", 'AA', 73, 76, 25],
    ["Dailyn Swain", 'ALA', 71, 86, 21],
    ["Patrick Williams", 'ALA', 71, 74, 25],
    ["Rob Dillingham", 'ARM', 70, 80, 21],
  ],
  "Dallas Mavericks": [
    ["Cooper Flagg", 'AP', 86, 99, 19],
    ["Naji Marshall", 'ALA', 80, 81, 28],
    ["Santi Aldama", 'AP', 80, 83, 25],
    ["P.J. Washington", 'ALA', 79, 80, 28],
    ["Max Christie", 'AA', 77, 83, 23, 'atirador'],
    ["Daniel Gafford", 'AP', 77, 78, 27, 'paredao'],
    ["Zaccharie Risacher", 'ALA', 74, 84, 21],
    ["Dereck Lively II", 'PIV', 73, 83, 22],
    ["John Poulakidas", 'AA', 72, 78, 23],
    ["Morez Johnson", 'AP', 72, 89, 20],
    ["Moussa Cisse", 'PIV', 72, 78, 23, 'sem3'],
    ["Marcus Sasser", 'ARM', 71, 74, 25],
    ["Dwight Powell", 'AP', 70, 70, 35, 'sem3'],
  ],
  "Denver Nuggets": [
    ["Nikola Jokic", 'PIV', 97, 97, 31, 'armador'],
    ["Jamal Murray", 'ARM', 90, 91, 29, 'atirador'],
    ["Aaron Gordon", 'ALA', 81, 81, 30, 'atirador'],
    ["Christian Braun", 'AA', 78, 81, 25],
    ["Cameron Johnson", 'ALA', 77, 77, 30, 'atirador'],
    ["Marvin Bagley III", 'AP', 77, 78, 27, 'sem3'],
    ["David Roddy", 'ALA', 76, 79, 25],
    ["Bruce Brown", 'AA', 74, 74, 30],
    ["Julian Strawther", 'AA', 72, 78, 24],
    ["Spencer Jones", 'ALA', 71, 74, 25],
    ["DaRon Holmes II", 'AP', 70, 76, 24, 'sem3'],
    ["KJ Simpson", 'ARM', 70, 76, 24, 'armador'],
    ["Curtis Jones", 'AA', 69, 75, 24],
  ],
  "Golden State Warriors": [
    ["Stephen Curry", 'ARM', 88, 88, 38, 'atirador'],
    ["Jimmy Butler III", 'ALA', 87, 87, 36],
    ["Kristaps Porzingis", 'AP', 81, 81, 31],
    ["Brandin Podziemski", 'AA', 80, 86, 23, 'atirador'],
    ["Brandon Williams", 'ARM', 78, 81, 26, 'armador'],
    ["Moses Moody", 'AA', 77, 83, 24, 'atirador'],
    ["De'Anthony Melton", 'AA', 77, 78, 28],
    ["Draymond Green", 'ALA', 77, 77, 36],
    ["Gui Santos", 'ALA', 76, 82, 24],
    ["Al Horford", 'AP', 76, 76, 40],
    ["Gary Payton II", 'AA', 75, 75, 33],
    ["Charles Bassey", 'PIV', 74, 77, 25],
    ["Yaxel Lendeborg", 'AP', 72, 87, 23],
  ],
  "Houston Rockets": [
    ["Kevin Durant", 'AP', 90, 90, 37, 'atirador'],
    ["Alperen Sengun", 'PIV', 88, 94, 24, 'sem3'],
    ["Amen Thompson", 'AA', 86, 92, 23],
    ["Jabari Smith Jr.", 'AP', 81, 87, 23],
    ["Reed Sheppard", 'AA', 79, 89, 22, 'atirador'],
    ["Tari Eason", 'ALA', 77, 80, 25],
    ["Steven Adams", 'PIV', 76, 76, 33, 'sem3'],
    ["Oscar Tshiebwe", 'AP', 76, 79, 26, 'sem3'],
    ["Marcus Smart", 'AA', 75, 75, 32],
    ["Clint Capela", 'PIV', 73, 73, 32, 'sem3'],
    ["Bogdan Bogdanovic", 'AA', 72, 72, 34],
    ["Aaron Holiday", 'AA', 70, 71, 29],
    ["Jae'Sean Tate", 'ALA', 68, 68, 30, 'sem3'],
  ],
  "Los Angeles Clippers": [
    ["Kawhi Leonard", 'ALA', 94, 94, 35, 'atirador'],
    ["Darius Garland", 'ARM', 83, 86, 26, 'armador'],
    ["Bennedict Mathurin", 'AA', 80, 86, 24],
    ["Jordan Miller", 'AA', 77, 80, 26],
    ["Max Strus", 'AA', 76, 76, 30],
    ["Derrick Jones Jr.", 'ALA', 76, 77, 29],
    ["Rui Hachimura", 'ALA', 76, 77, 28],
    ["Kris Dunn", 'AA', 75, 75, 32],
    ["Brook Lopez", 'PIV', 74, 74, 38],
    ["Isaiah Jackson", 'ALA', 74, 80, 24, 'sem3'],
    ["Keaton Wagler", 'AA', 73, 91, 19],
    ["Kobe Sanders", 'AA', 72, 78, 24],
    ["Jalen Pickett", 'ARM', 72, 75, 26],
  ],
  "Los Angeles Lakers": [
    ["Luka Doncic", 'ARM', 96, 97, 27, 'armador'],
    ["Austin Reaves", 'ARM', 88, 89, 28],
    ["Walker Kessler", 'PIV', 84, 87, 25],
    ["Collin Sexton", 'ARM', 79, 80, 27, 'atirador'],
    ["Quentin Grimes", 'AA', 78, 81, 26],
    ["Sandro Mamukelashvili", 'AP', 78, 79, 27],
    ["Ziaire Williams", 'AP', 75, 81, 24],
    ["Jake LaRavia", 'ALA', 74, 80, 24],
    ["Matisse Thybulle", 'AA', 73, 74, 29, 'defensor'],
    ["Jarred Vanderbilt", 'ALA', 72, 73, 27, 'sem3'],
    ["Jaden Hardy", 'AA', 72, 78, 24, 'atirador'],
    ["Kevon Looney", 'AP', 71, 71, 30, 'sem3'],
    ["Dalton Knecht", 'ALA', 68, 71, 25],
  ],
  "Miami Heat": [
    ["Giannis Antetokounmpo", 'AP', 95, 95, 31, 'sem3'],
    ["Bam Adebayo", 'AP', 87, 88, 29],
    ["Andrew Wiggins", 'ALA', 80, 80, 31, 'atirador'],
    ["Bobby Portis Jr.", 'AP', 79, 79, 31, 'atirador'],
    ["Davion Mitchell", 'ARM', 78, 79, 27, 'armador'],
    ["Pelle Larsson", 'AA', 77, 80, 25],
    ["Tim Hardaway Jr.", 'AA', 77, 77, 34, 'atirador'],
    ["Klay Thompson", 'AA', 75, 75, 36, 'atirador'],
    ["Simone Fontecchio", 'ALA', 74, 74, 30, 'atirador'],
    ["Dru Smith", 'ARM', 73, 74, 28],
    ["Nikola Jovic", 'AP', 72, 78, 23],
    ["Nick Richards", 'PIV', 71, 72, 28, 'sem3'],
    ["Myron Gardner", 'ALA', 71, 74, 25, 'sem3'],
  ],
  "Milwaukee Bucks": [
    ["Kevin Porter Jr.", 'ARM', 85, 88, 26, 'armador'],
    ["Tyler Herro", 'AA', 84, 87, 26, 'atirador'],
    ["Ryan Rollins", 'ARM', 82, 88, 24, 'armador'],
    ["Jaime Jaquez Jr.", 'AA', 81, 84, 25, 'armador'],
    ["Kel'el Ware", 'PIV', 79, 89, 22],
    ["Kyle Kuzma", 'ALA', 78, 78, 31],
    ["Cormac Ryan", 'AA', 78, 79, 27],
    ["Myles Turner", 'PIV', 77, 77, 30, 'atirador'],
    ["AJ Green", 'AA', 75, 78, 26, 'atirador'],
    ["Caris LeVert", 'AA', 74, 74, 32],
    ["Ousmane Dieng", 'AP', 73, 79, 23],
    ["Brayden Burries", 'AA', 72, 89, 20],
    ["Jericho Sims", 'PIV', 72, 73, 27, 'sem3'],
  ],
  "Minnesota Timberwolves": [
    ["Anthony Edwards", 'AA', 90, 93, 25, 'atirador'],
    ["LaMelo Ball", 'ARM', 86, 89, 25, 'armador'],
    ["Rudy Gobert", 'PIV', 81, 81, 34, 'paredao'],
    ["Ayo Dosunmu", 'ARM', 80, 83, 26, 'atirador'],
    ["Jaden McDaniels", 'AP', 79, 82, 25],
    ["Donte DiVincenzo", 'AA', 78, 79, 29, 'atirador'],
    ["Jonathan Kuminga", 'ALA', 78, 84, 23],
    ["Bones Hyland", 'ARM', 75, 78, 25, 'atirador'],
    ["Rocco Zikarsky", 'PIV', 74, 87, 20],
    ["Cody Williams", 'ALA', 73, 83, 21],
    ["Zyon Pullin", 'ARM', 71, 74, 25],
    ["Joan Beringer", 'AP', 71, 84, 19, 'sem3'],
    ["Enrique Freeman", 'AP', 71, 74, 26],
  ],
  "Brooklyn Nets": [
    ["Michael Porter Jr.", 'AP', 87, 88, 28],
    ["Julius Randle", 'AP', 86, 86, 31],
    ["Day'Ron Sharpe", 'PIV', 78, 84, 24, 'sem3'],
    ["Egor Demin", 'AA', 76, 89, 20, 'atirador'],
    ["Noah Clowney", 'AP', 76, 86, 22],
    ["Danny Wolf", 'AP', 75, 85, 22],
    ["Chaney Johnson", 'AA', 75, 81, 24],
    ["Josh Minott", 'ALA', 74, 80, 23],
    ["Mikel Brown Jr.", 'AA', 73, 90, 20],
    ["Nolan Traore", 'ARM', 73, 86, 20, 'armador'],
    ["Terance Mann", 'AA', 73, 74, 29],
    ["Moritz Wagner", 'AP', 73, 74, 29, 'sem3'],
    ["Ben Saraf", 'AA', 72, 85, 20, 'armador'],
  ],
  "New York Knicks": [
    ["Jalen Brunson", 'ARM', 89, 89, 30, 'armador'],
    ["Karl-Anthony Towns", 'PIV', 87, 87, 30, 'atirador'],
    ["Josh Hart", 'ARM', 81, 81, 31],
    ["OG Anunoby", 'ALA', 81, 82, 29, 'atirador'],
    ["Mikal Bridges", 'AA', 81, 81, 30, 'atirador'],
    ["Miles McBride", 'AA', 77, 80, 25, 'atirador'],
    ["Andre Drummond", 'PIV', 76, 76, 33, 'sem3'],
    ["Jose Alvarado", 'ARM', 75, 76, 28, 'armador'],
    ["Landry Shamet", 'AA', 74, 75, 29, 'atirador'],
    ["Jordan Clarkson", 'AA', 72, 72, 34],
    ["Tyler Kolek", 'ARM', 72, 75, 25, 'armador'],
    ["Mohamed Diawara", 'AP', 69, 79, 21, 'sem3'],
    ["Pacome Dadiet", 'AP', 68, 78, 21, 'sem3'],
  ],
  "Orlando Magic": [
    ["Paolo Banchero", 'AP', 88, 94, 23],
    ["Franz Wagner", 'AP', 84, 87, 25],
    ["Desmond Bane", 'AA', 83, 84, 28, 'atirador'],
    ["Nikola Vucevic", 'PIV', 82, 82, 35, 'atirador'],
    ["Jalen Suggs", 'ARM', 81, 84, 25, 'armador'],
    ["Anthony Black", 'AA', 79, 89, 22],
    ["Wendell Carter Jr.", 'PIV', 79, 80, 27],
    ["Tristan da Silva", 'ALA', 76, 79, 25, 'atirador'],
    ["Goga Bitadze", 'PIV', 75, 76, 27, 'sem3'],
    ["Jevon Carter", 'AA', 71, 71, 30],
    ["Malaki Branham", 'ALA', 71, 77, 23, 'sem3'],
    ["Jamal Cain", 'ALA', 71, 72, 27, 'sem3'],
    ["Noah Penda", 'AA', 70, 80, 21],
  ],
  "Indiana Pacers": [
    ["Pascal Siakam", 'ALA', 86, 86, 32],
    ["Andrew Nembhard", 'ARM', 82, 85, 26, 'armador'],
    ["Ivica Zubac", 'PIV', 82, 83, 29, 'sem3'],
    ["Obi Toppin", 'AP', 79, 80, 28],
    ["T.J. McConnell", 'ARM', 79, 79, 34, 'armador'],
    ["Kelly Oubre Jr.", 'ALA', 78, 78, 30],
    ["Jarace Walker", 'ALA', 77, 83, 23, 'atirador'],
    ["Aaron Nesmith", 'AA', 77, 80, 26, 'atirador'],
    ["Jalen Slawson", 'ALA', 76, 79, 26],
    ["Quenton Jackson", 'ARM', 75, 76, 27],
    ["Jay Huff", 'PIV', 75, 76, 29],
    ["Ben Sheppard", 'AA', 72, 75, 25],
    ["Johnny Furphy", 'AA', 71, 81, 21],
  ],
  "Philadelphia 76ers": [
    ["Tyrese Maxey", 'ARM', 93, 96, 25, 'armador'],
    ["Jaylen Brown", 'AA', 92, 93, 29, 'armador'],
    ["Joel Embiid", 'PIV', 91, 91, 32],
    ["LeBron James", 'AP', 89, 89, 41, 'armador'],
    ["VJ Edgecombe", 'AA', 81, 91, 21],
    ["Anfernee Simons", 'AA', 78, 79, 27, 'atirador'],
    ["Caleb Love", 'AA', 75, 81, 24],
    ["Dominick Barlow", 'AP', 75, 81, 23, 'sem3'],
    ["Kentavious Caldwell-Pope", 'AA', 74, 74, 33],
    ["Dean Wade", 'AP', 73, 74, 29],
    ["MarJon Beauchamp", 'ALA', 72, 75, 25],
    ["Tyrese Martin", 'ALA', 72, 73, 27],
    ["Justin Edwards", 'ALA', 71, 81, 22],
  ],
  "Phoenix Suns": [
    ["Devin Booker", 'ARM', 89, 90, 29, 'armador'],
    ["Miles Bridges", 'ALA', 82, 83, 28],
    ["Dillon Brooks", 'AA', 80, 80, 30],
    ["Jalen Green", 'AA', 80, 86, 24],
    ["Collin Gillespie", 'ARM', 80, 81, 27, 'atirador'],
    ["Mark Williams", 'PIV', 80, 86, 24, 'sem3'],
    ["Jordan Goodwin", 'AA', 77, 78, 27, 'atirador'],
    ["Luke Kennard", 'AA', 75, 75, 30],
    ["Oso Ighodaro", 'AP', 75, 81, 24, 'sem3'],
    ["Pat Spencer", 'ARM', 74, 74, 30, 'armador'],
    ["Ryan Dunn", 'ALA', 73, 79, 23],
    ["Jamaree Bouyea", 'AA', 73, 74, 27],
    ["Haywood Highsmith", 'ALA', 72, 73, 29],
  ],
  "Portland Trail Blazers": [
    ["Deni Avdija", 'ARM', 89, 92, 25, 'armador'],
    ["Ja Morant", 'ARM', 84, 85, 27, 'armador'],
    ["Jrue Holiday", 'ARM', 83, 83, 36, 'armador'],
    ["Shaedon Sharpe", 'AA', 82, 88, 23],
    ["Donovan Clingan", 'PIV', 82, 92, 22],
    ["Robert Williams III", 'AP', 79, 80, 28, 'paredao'],
    ["Jayson Kent", 'ALA', 78, 84, 24],
    ["Scoot Henderson", 'ARM', 78, 88, 22],
    ["Toumani Camara", 'ALA', 78, 81, 26, 'atirador'],
    ["Micah Potter", 'PIV', 76, 77, 28],
    ["Branden Carlson", 'PIV', 73, 74, 27],
    ["Vit Krejci", 'AA', 73, 76, 26, 'atirador'],
    ["Blake Wesley", 'ARM', 70, 76, 23, 'armador'],
  ],
  "Sacramento Kings": [
    ["Domantas Sabonis", 'AP', 83, 83, 30, 'sem3'],
    ["Zach LaVine", 'AA', 80, 80, 31, 'atirador'],
    ["Keegan Murray", 'ALA', 79, 82, 26],
    ["Maxime Raynaud", 'PIV', 78, 84, 23, 'sem3'],
    ["Precious Achiuwa", 'ALA', 77, 80, 26, 'sem3'],
    ["De'Andre Hunter", 'ALA', 77, 78, 28],
    ["Malik Monk", 'ARM', 76, 77, 28, 'atirador'],
    ["Nique Clifford", 'AA', 74, 80, 24],
    ["Daeqwon Plowden", 'AA', 74, 75, 28],
    ["Dylan Cardwell", 'PIV', 74, 80, 24, 'paredao'],
    ["Darius Acuff Jr.", 'AA', 73, 90, 19],
    ["Jonathan Mogbo", 'AP', 68, 74, 24, 'sem3'],
    ["Emanuel Sharp", 'AA', 66, 77, 22],
  ],
  "San Antonio Spurs": [
    ["Victor Wembanyama", 'AP', 95, 99, 22],
    ["De'Aaron Fox", 'ARM', 84, 85, 28, 'armador'],
    ["Stephon Castle", 'ARM', 84, 94, 21, 'armador'],
    ["Tobias Harris", 'ALA', 80, 80, 34],
    ["Dylan Harper", 'ARM', 79, 92, 20, 'armador'],
    ["Keldon Johnson", 'AA', 79, 82, 26],
    ["Devin Vassell", 'AA', 79, 82, 26, 'atirador'],
    ["Julian Champagnie", 'ALA', 78, 81, 25, 'atirador'],
    ["Luke Kornet", 'PIV', 76, 76, 31, 'sem3'],
    ["Harrison Barnes", 'ALA', 75, 75, 34, 'atirador'],
    ["David Jones Garcia", 'ARM', 73, 79, 24],
    ["Jayden Quaintance", 'AP', 70, 86, 19],
    ["Taelon Peter", 'AA', 69, 75, 24],
  ],
  "Oklahoma City Thunder": [
    ["Shai Gilgeous-Alexander", 'ARM', 96, 97, 28, 'armador'],
    ["Chet Holmgren", 'PIV', 86, 92, 24],
    ["Jalen Williams", 'AA', 84, 87, 25, 'armador'],
    ["Isaiah Hartenstein", 'PIV', 81, 82, 28, 'sem3'],
    ["Ajay Mitchell", 'AA', 80, 86, 24],
    ["Jaylin Williams", 'AP', 77, 83, 24],
    ["Cason Wallace", 'AA', 76, 86, 22, 'defensor'],
    ["Alex Caruso", 'AA', 75, 75, 32],
    ["Jared McCain", 'AA', 73, 83, 22],
    ["Kenrich Williams", 'AA', 73, 73, 31],
    ["Aday Mara", 'PIV', 72, 87, 21],
    ["Thomas Sorber", 'PIV', 71, 88, 20],
    ["Nikola Topic", 'ARM', 71, 81, 21],
  ],
  "Toronto Raptors": [
    ["Scottie Barnes", 'ALA', 87, 90, 25],
    ["Brandon Ingram", 'ALA', 85, 86, 29, 'atirador'],
    ["Immanuel Quickley", 'ARM', 83, 84, 27, 'armador'],
    ["RJ Barrett", 'AA', 82, 85, 26],
    ["Jakob Poeltl", 'PIV', 78, 78, 30, 'sem3'],
    ["Malachi Smith", 'ARM', 76, 79, 26],
    ["Collin Murray-Boyles", 'ALA', 76, 86, 21, 'sem3'],
    ["Kyle Anderson", 'ALA', 75, 75, 32, 'sem3'],
    ["Jamal Shead", 'ARM', 75, 81, 24, 'armador'],
    ["Ja'Kobe Walter", 'AA', 72, 82, 21],
    ["Gradey Dick", 'AA', 71, 81, 22],
    ["Allen Graves", 'AP', 71, 87, 20],
    ["A.J. Lawson", 'AA', 70, 73, 26],
  ],
  "Utah Jazz": [
    ["Lauri Markkanen", 'AP', 88, 89, 29],
    ["Keyonte George", 'ARM', 85, 95, 22, 'armador'],
    ["Jaren Jackson Jr.", 'AP', 82, 85, 26],
    ["Jusuf Nurkic", 'PIV', 80, 80, 32, 'sem3'],
    ["Kyle Filipowski", 'PIV', 78, 88, 22],
    ["Isaiah Collier", 'ARM', 78, 88, 21, 'armador'],
    ["Brice Sensabaugh", 'ALA', 77, 87, 22, 'atirador'],
    ["Blake Hinson", 'ALA', 76, 79, 26],
    ["Ace Bailey", 'AP', 76, 89, 20],
    ["Bez Mbeng", 'AA', 76, 82, 23, 'defensor'],
    ["Jaxson Hayes", 'PIV', 75, 78, 26, 'sem3'],
    ["Svi Mykhailiuk", 'AA', 74, 75, 29, 'atirador'],
    ["Darryn Peterson", 'AA', 74, 91, 19],
  ],
  "Memphis Grizzlies": [
    ["Ty Jerome", 'ARM', 85, 86, 29, 'armador'],
    ["Zach Edey", 'PIV', 84, 90, 24],
    ["Jerami Grant", 'ALA', 80, 80, 32, 'atirador'],
    ["Cedric Coward", 'AA', 79, 89, 22],
    ["Cam Spencer", 'ARM', 79, 82, 26, 'armador'],
    ["GG Jackson", 'AP', 77, 87, 21],
    ["Scotty Pippen Jr.", 'ARM', 76, 79, 25],
    ["D'Angelo Russell", 'ARM', 76, 76, 30, 'armador'],
    ["Javon Small", 'ARM', 76, 82, 23, 'armador'],
    ["Isaiah Stewart", 'AP', 76, 79, 25],
    ["Jaylen Wells", 'ALA', 75, 81, 23],
    ["Olivier-Maxence Prosper", 'ALA', 75, 81, 24],
    ["Quinten Post", 'PIV', 74, 77, 26],
  ],
  "Washington Wizards": [
    ["Anthony Davis", 'AP', 87, 87, 33, 'paredao'],
    ["Trae Young", 'ARM', 82, 83, 27, 'armador'],
    ["Alex Sarr", 'PIV', 81, 91, 21],
    ["Deandre Ayton", 'PIV', 79, 80, 28, 'sem3'],
    ["Kyshawn George", 'ALA', 79, 89, 22, 'atirador'],
    ["Bilal Coulibaly", 'AA', 77, 87, 22],
    ["Bub Carrington", 'ARM', 75, 85, 21, 'atirador'],
    ["Justin Champagnie", 'AA', 75, 78, 25],
    ["Tre Johnson", 'AA', 75, 88, 20],
    ["Khris Middleton", 'ALA', 75, 75, 35],
    ["Tristan Vukcevic", 'AP', 74, 80, 23],
    ["AJ Dybantsa", 'AP', 74, 92, 19],
    ["Sharife Cooper", 'ARM', 74, 77, 25, 'armador'],
  ],
  "Detroit Pistons": [
    ["Cade Cunningham", 'ARM', 93, 99, 24, 'armador'],
    ["Jalen Duren", 'PIV', 89, 99, 22, 'sem3'],
    ["Ausar Thompson", 'AA', 79, 85, 23, 'defensor'],
    ["Paul Reed", 'AP', 78, 79, 27, 'sem3'],
    ["John Collins", 'AP', 78, 79, 28],
    ["Duncan Robinson", 'ALA', 77, 77, 32, 'atirador'],
    ["Isaiah Joe", 'AA', 76, 77, 27, 'atirador'],
    ["Daniss Jenkins", 'ARM', 76, 79, 25, 'armador'],
    ["Kevin Huerter", 'AA', 76, 77, 28],
    ["Ronald Holland II", 'ALA', 75, 85, 21],
    ["Taurean Prince", 'ALA', 74, 74, 32, 'atirador'],
    ["Javonte Green", 'AA', 74, 74, 33],
    ["Elijah Harkless", 'AA', 72, 75, 26],
  ],
  "Charlotte Hornets": [
    ["Brandon Miller", 'ALA', 83, 89, 23, 'atirador'],
    ["Kon Knueppel", 'AA', 82, 92, 21, 'atirador'],
    ["Coby White", 'ARM', 80, 83, 26, 'armador'],
    ["Grayson Allen", 'ARM', 80, 80, 30],
    ["Naz Reid", 'AP', 80, 81, 27],
    ["Moussa Diabate", 'AP', 78, 84, 24, 'sem3'],
    ["Royce O'Neale", 'ALA', 77, 77, 33, 'atirador'],
    ["Dennis Schroder", 'ARM', 77, 77, 32, 'armador'],
    ["Ryan Kalkbrenner", 'PIV', 76, 82, 24, 'sem3'],
    ["Grant Williams", 'ALA', 75, 76, 27],
    ["Tidjane Salaun", 'AP', 73, 83, 21],
    ["Sion James", 'AA', 72, 78, 23],
    ["Christian Anderson", 'AA', 71, 87, 20],
  ],
};
